<div id="forgot-password-page">
  <app-minimalist-entry>
    <a slot="link" [routerLink]="['/login']">
      <span
        style="margin-left: 10px; color: #29B5E8; cursor: pointer"
        i18n="forgot password exit button|The label of the button or link that allows the user to leave the forgot password page to return to the login page without sending the password change request@@goBackFromForgotPassword"
      >Go back</span>
    </a>
    <div slot="content">
      <form class="form-login" [formGroup]="form" spellcheck="false">
        <div class="form-inner-group input-group email">
          <input
            formControlName="email"
            type="email"
            class="form-control"
            i18n-placeholder="email address placeholder|The placeholder that is visible at an email address input before a content is written to it@@emailAddressPlaceholder"
            placeholder="Email Address"
            autocomplete="email"
            pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$"
            [readonly]="this.loading"
            spellcheck="false"
            autofocus
            required
          >
        </div>
        <div [ngClass]="{'form-inner-group': true, 'captcha-wrapper': true, 'visible': captchaVisibleAnimation}" *ngIf="!successfullySent">
          <re-captcha (resolved)="onCaptchaResolved($event)" siteKey="6LdbK30UAAAAAKNqX3sLt1fQhe8aUrPKy2vVCMHI"></re-captcha>
        </div>
        <div class="form-inner-group alert-wrapper" *ngIf="(attemptedSubmit && form.invalid && form.dirty)">
          <div *ngIf="(form.invalid && form.dirty)">
            <ul class="alert alert-danger">
              <li
                *ngIf="email.invalid"
                i18n="email is required|Error message for when the email is missing or invalid@@emailRequired"
              >Email is required</li>
              <li
                *ngIf="token.invalid"
                i18n="recaptcha is required|Error message for when the required recaptcha has not been filled or clicked by a human@@recaptchaRequired"
              >Fill recaptcha form to prove you're a human</li>
              <li
                *ngIf="!(email.invalid) && !token.invalid"
                i18n="generic form validation error message|A generic message to show to the user when some generic and unspecified input is invalid or empty@@genericInvalidFormMessage"
              >Please fill the form inputs correctly</li>
            </ul>
          </div>
        </div>
        <div class="form-inner-group alert alert-danger" *ngIf="errorMessage">{{ errorMessage }}</div>
        <div
          class="form-inner-group alert alert-success"
          *ngIf="successfullySent"
          i18n="successfull forgot password result message|The message that shows up once the user successfully sent the request to get a token to reset his password@@successfullForgotPasswordMessage"
        >You will receive a link in your email to reset your password.</div>
        <div class="form-inner-group actions">
          <button type="submit" class="btn btn-theme btn-block btn-with-left-icon login" (click)="onSubmitClick()" [disabled]="successfullySent">
            <i *ngIf="!loading" class="fa fa-lock"></i>
            <i *ngIf="loading" class="fa fa-circle-o-notch fa-spin btn-with-left-icon"></i>
            <span
              *ngIf="!successfullySent"
              i18n="password reset request button label|The main submit button label for the reset password form page@@forgotPasswordButtonLabel"
            >Submit</span>
            <span
              *ngIf="successfullySent"
              i18n="successfull password reset request button label|The main submit button label for the reset password form page once the user successfully submits the request@@successfullForgotPasswordButtonLabel"
            >Done!</span>
          </button>
        </div>
      </form>
    </div>
  </app-minimalist-entry>
</div>
